// extracted by mini-css-extract-plugin
export var footer = "_qo-5";
export var fulfillmentInput = "_qo-0";
export var shipDateInput = "_qo-1";
export var shipmentModal = "_qo-2";
export var shipmentModalContent = "_qo-3";
export var tableContainer = "_qo-4";